module.exports = __webpack_public_path__ + "static/media/driver.1297084f.svg";